import { request } from '../../http';

class Model {

  /**
   * 用户修改密码
   */
  resetPwd(data) {
    return request('/user/resetPwd', {
      method: 'POST',
      data,
    });
  }

  /**
   * 运营端重制密码
   */
  resetOperationPwd(data) {
    return request('/staff/resetPwd', {
      method: 'POST',
      data,
    });
  }

  // 发送验证码
  sendOtp(data) {
    return request(`index/sendCaptcha`, {
      method: 'POST',
      data,
    });
  }
}

export default new Model();
